import React, { Component } from 'react';
import { object, string, func, bool, array } from 'prop-types';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import TabsBar from '@components/TabsBar';
import Toggle from 'elements/Toggle/Toggle';
import Divider from 'elements/Divider/Divider';
import Svg from '../Svg';

import { toggleDarkMode } from '@actions/viewModeActions';

import styles from './TopBanner.css';

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleDarkMode,
}, dispatch);

const mapStateToProps = ({ viewMode }) => ({
  isDarkMode: viewMode.isDarkMode,
});

class TopBanner extends Component {
  static propTypes = {
    customStyles  : object,
    title         : string,
    subtitle      : string,
    toggleDarkMode: func,
    isDarkMode    : bool,
    tabs          : array,
  };

  render() {
    const {
      subtitle,
      title,
      customStyles,
      toggleDarkMode,
      isDarkMode,
      tabs,
    } = this.props;

    const bulbClass = classnames(styles.bulb, isDarkMode ? 'off' : 'on');
    const hasDarkMode = false; // Todo: implement darkmode feature

    return (
      <div className={classnames(styles.banner, 'main-content')} styles={customStyles}>
        <div>
          <span className={styles.subtitle}>{subtitle}</span>
          <div className={styles.mainWrapper}>
            <h1 className={styles.title}>{title}</h1>
            { hasDarkMode &&
              <div className={styles.toggleContainer}>
                <Toggle onChange={toggleDarkMode} checked={isDarkMode}/>
                <Svg name="light-bulb" className={bulbClass}/>
              </div>
            }
          </div>
        </div>
        { tabs && tabs.length ? <TabsBar tabs={tabs}/> : <Divider /> }
      </div>
    );
  }
}

TopBanner.displayName = 'TopBanner';

export default connect(mapStateToProps, mapDispatchToProps)(TopBanner);



// WEBPACK FOOTER //
// ./src/components/TopBanner/TopBanner.js